import React from "react";
import { Link } from "react-router-dom";
import { FaLocationDot, FaUser } from "react-icons/fa6";

const Destacados = ({ categoria, setCategoria, ofertas, recursos, cursos }) => {
  const normalize = (str) =>
    str?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  const formatearFecha = (isoDate) => {
    const fecha = new Date(isoDate);
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const año = fecha.getFullYear();
    return `${dia}/${mes}/${año}`;
  };

  const categoriasSociales = ["vivienda", "prestaciones", "subvenciones", "social"];
  const recursosSociales = recursos.filter((r) => categoriasSociales.includes(normalize(r.category)));
  const recursosOtros = recursos.filter((r) => !categoriasSociales.includes(normalize(r.category)));

  const renderOfertas = () =>
    ofertas.map((oferta) => (
      <div key={oferta._id} className="recurso">
        <p className="etiqueta verde">#Oferta de empleo</p>
        <h2 className="mayusculas mt-20">{oferta.title}</h2>
        <p>{oferta.company}</p>
        <p className="fecha">Publicado el: {formatearFecha(oferta.publicationDate)}</p>
        <p className="align-center gap-5 ubicacion"><FaLocationDot />{oferta.location}</p>
        <Link className="verde" to={`/empleo/${oferta._id}`}>Más información</Link>
      </div>
    ));

  const renderCursos = () =>
    cursos.map((curso, index) => (
      <div key={index} className="recurso formacion">
        <p className="etiqueta rosa">#Curso</p>
        <h2 className="mayusculas mt-20">{curso.title}</h2>
        <p>{curso.institutionalFacility}</p>
        <p className="fecha">
          {formatearFecha(curso.startDate)} - {formatearFecha(curso.endDate)}
        </p>
        <p className="align-center gap-5 ubicacion">
          <FaUser />{curso.targetUsers}
        </p>
        <Link className="rosa" to={`/formacion/${curso._id}`}>Más información</Link>
      </div>
    ));

  const renderSociales = () =>
    recursosSociales.map((recurso) => (
      <div key={recurso._id} className="recurso azul column">
        <p className="etiqueta azul">#{recurso.category}</p>
        <h2 className="mayusculas negro">{recurso.title}</h2>
        <Link className="azul" to={`/recurso-social/${recurso._id}`}>Más información</Link>
      </div>
    ));

  const renderOtros = () =>
    recursosOtros.map((recurso) => (
      <div key={recurso._id} className="recurso naranja">
        <p className="etiqueta naranja">#Recurso</p>
        <h2 className="negro mayusculas mt-20">{recurso.title}</h2>
        <Link className="naranja" to={`/recurso/${recurso._id}`}>Más información</Link>
      </div>
    ));

  const renderContenido = () => {
    if (categoria === "empleo") return renderOfertas();
    if (categoria === "formacion") return renderCursos();
    if (categoria === "social") return renderSociales();
    if (categoria === "recursos") return renderOtros();
    if (categoria === "todas") {
      return (
        <>
          {renderOfertas()}
          {renderCursos()}
          {renderSociales()}
          {renderOtros()}
        </> 
      );
    }

    return <p>No hay contenido disponible.</p>;
  };

  return (
    <section className="seccion">
      <div className="seccion-noticias">
        <div className="align-center gap-5">
          <h2 className="titulo-user bold">
            NOVEDADES / DESTACADO:
            <select
              aria-label="Tipo de novedad"
              className="desplegable-empleo mayusculas ml-5"
              value={categoria}
              onChange={(e) => setCategoria(e.target.value)}
            >
              <option value="todas">TODO</option>
              <option value="empleo">empleo</option>
              <option value="formacion">Formación</option>
              <option value="social">social</option>
              <option value="recursos">recursos</option>
            </select>
          </h2>
        </div>

        <div className="align-center w-100 noticias-container noticias carrusel">
          {renderContenido()}
        </div>
      </div>
    </section>
  );
};

export default Destacados;